import { useMemo } from "react";
import { useGetMemberQuery, useGetMembersQuery } from "./memberEndpoints";
import { Member } from "../../entities/member";

export function useMyMember() {
  const memberQuery = useGetMemberQuery(null);
  const memberEntity = memberQuery.data;

  return useMemo(() => {
    const ret: typeof memberQuery & { member?: Member | undefined } = {
      ...memberQuery,
    };
    if (memberEntity) ret.member = new Member(memberEntity);
    return ret;
  }, [memberEntity]);
}

export function useMembers() {
  const memberQuery = useGetMembersQuery();
  const memberEntitiesMap = memberQuery.data?.entities;

  return useMemo(() => {
    const ret: typeof memberQuery & {
      members?: Member[];
      membersMap?: { [id: number]: Member };
    } = {
      ...memberQuery,
      members: [],
      membersMap: {},
    };
    if (memberEntitiesMap) {
      const members: Member[] = [];
      const membersMap: { [id: number]: Member } = {};

      for (const key in memberEntitiesMap) {
        if (Object.prototype.hasOwnProperty.call(memberEntitiesMap, key)) {
          const c = memberEntitiesMap[key];
          const member = new Member(c);
          members.push(member);
          membersMap[member.id] = member;
        }
      }
      ret.members = members;
      ret.membersMap = membersMap;
    }

    return ret;
  }, [memberEntitiesMap]);
}
